import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-partners-add',
  templateUrl: './partners-add.component.html',
  styleUrls: ['./partners-add.component.scss']
})
export class PartnersAddComponent implements OnInit {

  partner: any = {
    name_ar: '',
    name_en: '',
    url: '',
    order: '0',
    logo: null as File | string | null,
    description_ar: '',
    description_en: '',
  };

  jobTitles: any[] = [];
  previewUrl: string | null = null;

  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.fetchJobTitles();
  }

  fetchJobTitles(): void {
    this.apisService.getJobTitles().subscribe({
      next: (res) => this.jobTitles = res,
      error: () => this.toastr.error('Failed to load job titles')
    });
  }

  // ✅ دالة مساعدة: هل نعرض الشعار الحالي؟ (تجنب typeof في HTML)
  get showCurrentLogo(): boolean {
    return !!this.partner.logo && 
           typeof this.partner.logo === 'string' && 
           !this.previewUrl;
  }

  // 🖼️ اختيار صورة الشعار
  onFileSelected(event: any): void {
    if (event.target.files?.length > 0) {
      const file = event.target.files[0];
      this.partner.logo = file;
      this.previewLogo(file);
    }
  }

  // معاينة الصورة
  previewLogo(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.previewUrl = e.target.result;
    };
    reader.onerror = (error) => {
      console.error('Error previewing image:', error);
      this.toastr.error('Error loading image preview');
    };
    reader.readAsDataURL(file);
  }

  // إزالة الصورة الحالية
  removeCurrentLogo(): void {
    this.partner.logo = null;
    this.previewUrl = null;
  }

  // إزالة الصورة الجديدة المختارة
  removeNewLogo(): void {
    this.previewUrl = null;
    if (!(this.partner.logo instanceof File)) {
      this.partner.logo = null;
    }
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  cancel(): void {
    this.router.navigate(['/partners']);
  }

  getTranslation(translations: any[], locale: string) {
    return translations.find(translation => translation.locale === locale) || {};
  }

  // ✅ إرسال النموذج
  onSubmit(): void {
    if (!this.partner.name_ar || !this.partner.name_en || !this.partner.url) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.all_fields_required'));
      return;
    }

    const form = new FormData();
    
    form.append('name_ar', this.partner.name_ar.trim());
    form.append('name_en', this.partner.name_en.trim());
    form.append('url', this.partner.url);
    form.append('order', this.partner.order);
    
    if (this.partner.logo instanceof File) {
      form.append('logo', this.partner.logo);
    }
    
    form.append('description_ar', this.partner.description_ar?.trim() || '');
    form.append('description_en', this.partner.description_en?.trim() || '');

    this.apisService.addPartners(form).subscribe({
      next: (response: any) => {
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.partner_added_successfully'));
        this.resetForm();
        this.router.navigate(['/partners']);
      },
      error: (error: any) => {
        console.error('Error adding partners:', error);

        if (error.error?.errors) {
          const errors = error.error.errors;
          Object.keys(errors).forEach(key => {
            this.toastr.error(errors[key][0]);
          });
        } else {
          this.toastr.error(this.translate.instant('MENU.DASHBOARD.something_went_wrong'));
        }
      }
    });
  }

  // 🔄 إعادة تعيين النموذج
  resetForm(): void {
    this.partner = {
      name_ar: '',
      name_en: '',
      url: '',
      order: '0',
      logo: null,
      description_ar: '',
      description_en: '',
    };
    this.previewUrl = null;
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
}